var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadiconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0666 4.78315C14.8659 3.58218 13.3361 2.76423 11.6706 2.43274C10.0051 2.10126 8.27874 2.27113 6.70978 2.92087C5.14083 3.57061 3.79979 4.67104 2.85629 6.08299C1.91278 7.49493 1.40918 9.15496 1.40918 10.8531C1.40918 12.5513 1.91278 14.2113 2.85629 15.6233C3.79979 17.0352 5.14083 18.1357 6.70978 18.7854C8.27874 19.4351 10.0051 19.605 11.6706 19.2735C13.3361 18.942 14.8659 18.1241 16.0666 16.9231C16.8666 16.1276 17.5015 15.1818 17.9347 14.1401C18.368 13.0984 18.591 11.9813 18.591 10.8531C18.591 9.72492 18.368 8.60784 17.9347 7.56613C17.5015 6.52442 16.8666 5.57863 16.0666 4.78315ZM15.1522 16.0045C14.1326 17.0276 12.8323 17.7251 11.416 18.0088C9.9997 18.2924 8.53107 18.1494 7.19612 17.5978C5.86116 17.0462 4.71993 16.1108 3.91692 14.9102C3.11392 13.7095 2.68528 12.2976 2.68528 10.8531C2.68528 9.40871 3.11392 7.99676 3.91692 6.79611C4.71993 5.59546 5.86116 4.66011 7.19612 4.10851C8.53107 3.5569 9.9997 3.41386 11.416 3.69749C12.8323 3.98112 14.1326 4.67867 15.1522 5.7018C15.8328 6.37595 16.3731 7.1783 16.7418 8.06248C17.1105 8.94666 17.3004 9.89515 17.3004 10.8531C17.3004 11.8111 17.1105 12.7596 16.7418 13.6438C16.3731 14.528 15.8328 15.3303 15.1522 16.0045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.85156L12 10.8516L9 13.8516",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadiconsvg);
export default __webpack_public_path__ + "static/media/uploadiconsvg.974bc867ce819871587e82a70069b99b.svg";
export { ForwardRef as ReactComponent };